import {FocusedThumbnailProps} from "./types";
import Thumbnail from "./thumbnail";

const FocusedThumbnail = ({
  imageSrc,
  thumbnailSrc,
  ImageMetadataComponent,
  ImageCaptionComponent,
}: FocusedThumbnailProps) => {
  return (
    <div className="focused-thumbnail">
      <div className="mb-6 flex w-full justify-center">
        <div className="flex w-[800px] justify-evenly rounded-lg border-[1px] border-solid border-gray-200 bg-slate-50 p-5">
          <div className="flex flex-col">
            <h3 className="mb-2 text-lg font-medium leading-6 text-blue-200">
              Selected Image:
            </h3>
            <a href={imageSrc} target={"_blank"} rel="noreferrer">
              <Thumbnail src={thumbnailSrc} className={"max-h-xs mr-3 max-w-xs rounded-md"}/>
            </a>
            <div className={"max-w-xs text-center"}>
              <ImageCaptionComponent imageSrc={imageSrc} />
            </div>
          </div>
          <ImageMetadataComponent imageSrc={imageSrc} />
        </div>
      </div>
    </div>
  );
};

export default FocusedThumbnail;
